import React, { useCallback, useEffect, useState } from 'react'
import {
    useJsApiLoader,
    GoogleMap,
    Marker,
    InfoWindow,
    Autocomplete,
} from '@react-google-maps/api'
import "./map.css"
import { MapProp } from './InterfaceMap';
import Geocode, { setKey, setRegion, setLanguage, fromLatLng } from "react-geocode";
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { Grid, Tooltip, Typography } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import { useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import { CheckConditionGetValue, DefaultArrayEmpty, OpenNewTab } from 'utilities/utilities';

// const KeyMapAPI  = secureLocalStorage.getItem("MapAPI") as string;
// Geocode.setKey(KeyMapAPI);
// Geocode.setRegion("th");
// Geocode.setLanguage("th");

const KeyMapAPI = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
setKey(KeyMapAPI);
setRegion("th");
setLanguage("th");

const MapComponents = (props: MapProp) => {

    const {
        id,
        mapRef,
        IsMultiMarker = true,
        Isdisable = false,
        IsMarker = true,
        IsPopUp = true,
        IsSearch = true,
        IsFullScreen = true,
        IsMarkerSearch = true,
        IsDefaultThai = true,
        sHeight = "500px",
        arrMarker = [],
        markerSearch,
        setmarkerSearch,
        sSearch = "",
        latSearch,
        lngSearch,
        form,
        nZoomClick = 6,
        IsDefaultCustomPopup,
        PopUpCustomFix
    } = props;

    const [searchBox, setsearchBox] = useState() as any;
    const [isOpen, setIsOpen] = useState(false);
    const [isCanMarker, setisCanMarker] = useState(false)
    const [infoWindowData, setInfoWindowData] = useState(null);
    const [sInput, setsInput] = useState("")
    const [arrLocationThailand] = useState([
        { lat: 20.202186889782737, lng: 99.97373323585657 },
        { lat: 6.116302058707464, lng: 101.39298630298904 },
    ])
    const navigate = useNavigate();

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: KeyMapAPI, //`${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`,
        libraries: ['places'],
        id: 'google-map-script',
        // language: "th",
        // region: "th",
    })

    useEffect(() => {
        const map = mapRef?.current;
        if (map) {
            if (sSearch !== "" && sSearch !== null) {
                const service = new window.google.maps.places.PlacesService(map);
                getPosition(service, sSearch)
            }
            else if (latSearch && lngSearch) {
                getPositionFromLanLng(latSearch, lngSearch)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [latSearch, lngSearch, mapRef, sSearch]);

    useEffect(() => {
        const map = mapRef.current;
        if (map && arrMarker.length > 0) {
            const bounds = new google.maps.LatLngBounds();
            arrMarker.forEach(({ lat, lng }) => { if (lat && lng) { bounds.extend({ lat, lng }) } });

            map.fitBounds(bounds);
            if (setmarkerSearch) {
                setmarkerSearch(null)
            }
        }
    }, [arrMarker, mapRef, setmarkerSearch]);

    const getPosition = (service, sSearch) => {
        let request = {
            query: sSearch,
            fields: ["name", "formatted_address", "geometry"]
        };

        service.findPlaceFromQuery(request, async (results, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                let oResult = checkshortCondition(results.length > 0, results[0], null);
                if (oResult) {
                    let lat = parseFloat(oResult.geometry.location.lat());
                    let lng = parseFloat(oResult.geometry.location.lng());

                    await onSetMarker(lat, lng);
                    if (oResult.geometry.viewport) {
                        let bounds = new window.google.maps.LatLngBounds(oResult.geometry.viewport);
                        mapRef.current.fitBounds(bounds);
                    }
                }
            }
        });
    };

    const getPositionFromLanLng = (lat, lng) => {
        let nLat = parseFloat(lat)
        let nLng = parseFloat(lng)
        onSetMarker(nLat, nLng);
        let bounds = new window.google.maps.LatLngBounds({ lat: nLat, lng: nLng });
        mapRef.current.fitBounds(bounds);
    };

    const handleMarkerClick = async (id, item) => {
        if (item != null) {
            const { lat, lng } = item;
            if (IsPopUp) {
                let address = await getAddressfromLatLng(lat, lng)
                let childTicket = DefaultArrayEmpty(item.childTicket);
                setInfoWindowData({ id, address, lat, lng, url: getGoogleMapsUrl(lat, lng), childTicket: childTicket });
                mapRef.current.panTo({ lat, lng });
                mapRef.current.setZoom(nZoomClick);
                setIsOpen(true);
            }
        }
    };

    const onUnmount = React.useCallback(function callback(map) {
        mapRef.current = null;
    }, [mapRef])

    const onLoad = (mapInstance: google.maps.places.Autocomplete) => {
        setsearchBox(mapInstance);
    }

    const onPlaceChanged = async () => {
        if (searchBox !== null) {
            let place = searchBox.getPlace();
            let lat = parseFloat(place.geometry.location.lat());
            let lng = parseFloat(place.geometry.location.lng());
            setsInput(place.formatted_address);

            if (IsMarkerSearch) {
                await onSetMarker(lat, lng);
            }
            if (place.geometry.viewport) {
                let bounds = new window.google.maps.LatLngBounds(place.geometry.viewport);
                mapRef.current.fitBounds(bounds);
            }
        }
    }

    const onMapClick = async (event) => {
        if (!Isdisable && isCanMarker && IsMarker && event) {
            let onlatlng = event.latLng;
            let lat = parseFloat(onlatlng.lat());
            let lng = parseFloat(onlatlng.lng());
            await onSetMarker(lat, lng);
        }
    };

    const onSetMarker = async (lat, lng) => {
        let address = await getAddressfromLatLng(lat, lng)
        if (form) {
            form.setValue("sLatitude", lat)
            form.setValue("sLongitude", lng)
            form.setValue("sLocation", address)
        }
        let url = getGoogleMapsUrl(lat, lng);
        if (setmarkerSearch) {
            setmarkerSearch({ address: address, lat: lat, lng: lng, url: url, childTicket: [] })
        }
        setInfoWindowData({ id: 9999, address, lat, lng, url: url, childTicket: [] });
    }

    const deleteMarker = useCallback(() => {
        let arrMark = arrMarker;
        if (infoWindowData) {
            let findID = arrMark.findIndex(f => f.lat === infoWindowData.lat && f.lng === infoWindowData.lng);
            if (findID > -1) {
                arrMark.splice(findID, 1);
                setInfoWindowData(null)
                setIsOpen(false)
            }
        }
    }, [arrMarker, infoWindowData])

    const getAddressfromLatLng = async (ParamLat, ParamLng) => {
        let address = "";
        if (ParamLat && ParamLng) {
            await fromLatLng(ParamLat, ParamLng).then(
                (response) => {
                    let result = response.results[0];
                    address = result.formatted_address;
                }
            );
        }
        else if (form) {
            form.setValue("sLatitude", null)
            form.setValue("sLongitude", null)
            form.setValue("sLocation", null)
        }
        return address;
    }

    return (
        <div id={id} style={{ width: '100%', height: '100%', position: 'relative' }}>
            {!isLoaded ? (
                <h1>Loading...</h1>
            ) :
                (
                    <>
                        <BtnMarkerInMap
                            IsMarker={IsMarker}
                            isCanMarker={isCanMarker}
                            setisCanMarker={setisCanMarker}
                        />
                        <GoogleMap
                            mapContainerStyle={{
                                width: '100%',
                                height: sHeight,
                                borderRadius: '14px',
                                boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                            }}
                            // onLoad={onMapLoad}
                            onLoad={map => {
                                mapRef.current = map;
                                if (arrMarker && arrMarker.length > 0) {
                                    const bounds = new google.maps.LatLngBounds();
                                    arrMarker?.forEach(({ lat, lng }) => {
                                        if (lat && lng) {
                                            bounds.extend({ lat, lng })
                                        }
                                    });
                                    mapRef.current.fitBounds(bounds);
                                }
                                else if (IsDefaultThai) {
                                    const bounds = new google.maps.LatLngBounds();
                                    //Default Thailand
                                    arrLocationThailand.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
                                    mapRef.current.fitBounds(bounds);
                                }
                                else if (markerSearch) {
                                    const bounds = new google.maps.LatLngBounds();
                                    [markerSearch].forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
                                    mapRef.current.fitBounds(bounds);
                                }
                            }}
                            onUnmount={onUnmount}

                            zoom={5}
                            onClick={(e) => {
                                setIsOpen(false);
                                onMapClick(e);
                            }}
                            options={{
                                streetViewControl: false,
                                scaleControl: true,
                                fullscreenControl: IsFullScreen,
                                disableDoubleClickZoom: true,
                                // disableDefaultUI: Isdisable,
                                scrollwheel: false,
                                gestureHandling: "cooperative",
                                disableDefaultUI: true, //false,
                                minZoom: 3,
                                maxZoom: 18,
                                mapTypeControl: false,
                                mapTypeId: google.maps.MapTypeId.ROADMAP,
                                mapTypeControlOptions: {
                                    style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                                    position: google.maps.ControlPosition.BOTTOM_CENTER,
                                },
                                zoomControl: true,
                                zoomControlOptions: {
                                    position: google.maps.ControlPosition.RIGHT_BOTTOM,
                                }
                            }}
                        >
                            {IsSearch && <Autocomplete
                                onLoad={onLoad}
                                onPlaceChanged={onPlaceChanged}
                            >
                                <div className="input-container">
                                    <input
                                        id='search-map'
                                        type="text"
                                        placeholder="ค้นหาพื้นที่"
                                        className='input-search-map'
                                        value={sInput}
                                        onChange={(e) => {
                                            setsInput(e.target.value);

                                        }}
                                    />
                                    <SearchIcon className="input-icon" />
                                </div>
                            </Autocomplete>}
                            {
                                IsDefaultCustomPopup ?
                                    <>
                                        <Marker
                                            position={{ lat: 13.762249, lng: 100.527675 }}
                                            animation={google.maps.Animation.DROP}
                                        ></Marker>
                                        <InfoWindow
                                            position={{ lat: 13.762439, lng: 100.527675 }}
                                        >
                                            <div>
                                                <Grid container spacing={2} justifyContent={"flex-start"} alignItems={"flex-end"}>
                                                    <Grid item xs={12} >
                                                        <Typography fontSize={16} fontWeight={500} >อาคารโกเมน</Typography>
                                                        <Typography fontSize={13} > QG6H+V3V ถ. พระรามที่ 6 แขวงทุ่งพญาไท เขตราชเทวี กรุงเทพมหานคร 10400</Typography>
                                                        <div
                                                            data-testid={"ViewOnGoogle"}
                                                            className='underline-on-hover-text'
                                                            onClick={() => { OpenNewTab(`https://www.google.com/maps/search/?api=1&query=13.762249,100.527675`); }}
                                                        >
                                                         <Typography fontSize={13}> ดูบน Google Maps</Typography>  
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        </InfoWindow>
                                    </>
                                    :
                                    null
                            }

                            {markerSearch != null && !IsDefaultCustomPopup && <Marker
                                position={{ lat: markerSearch?.lat, lng: markerSearch?.lng }}
                                draggable={false}
                                animation={google.maps.Animation.DROP}
                                onClick={async () => {
                                    await handleMarkerClick(9999, markerSearch);
                                }}
                            >
                                {IsPopUp && isOpen && infoWindowData?.id === 9999 && (
                                    <PopUpInfoMapComponent
                                        setIsOpen={setIsOpen}
                                        infoWindowData={infoWindowData}
                                        navigate={navigate}
                                        deleteMarker={deleteMarker}
                                        Isdisable={Isdisable}
                                        isCanMarker={isCanMarker}
                                    />
                                )}
                            </Marker>}

                            {IsMultiMarker && arrMarker.map((item, ind) => {
                                let sLabel = checkshortCondition(item.label === "1", "", item.label);
                                let sKey = ind + "_" + item.lat
                                return (
                                    <Marker
                                        key={sKey}
                                        position={{ lat: item.lat, lng: item.lng }}
                                        animation={google.maps.Animation.DROP}
                                        draggable={false}
                                        label={sLabel}
                                        onClick={() => {
                                            handleMarkerClick(ind, item);
                                        }}
                                    >
                                        {isOpen && infoWindowData?.id === ind && (
                                            <PopUpInfoMapComponent
                                                setIsOpen={setIsOpen}
                                                infoWindowData={infoWindowData}
                                                navigate={navigate}
                                                deleteMarker={deleteMarker}
                                                Isdisable={Isdisable}
                                                isCanMarker={isCanMarker}
                                            />
                                        )}
                                    </Marker>
                                )
                            })}
                        </GoogleMap>

                    </>
                )
            }
        </div >
    )
}
export default MapComponents

export const getGoogleMapsUrl = (lat, lng) => {
    const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
    return url;
};

export const goToDetailProject = (navigate, nProjectID, nAreaID) => {
    if (nProjectID) {
        navigate(`/ProjectReport`,
            {
                state:
                {
                    nProjectID: nProjectID,
                    nAreaID: nAreaID,
                    sModeBtn: "View",
                }
            }
        );
    }
}

export const BtnMarkerInMap = ({
    IsMarker,
    isCanMarker,
    setisCanMarker,
}) => {
    if (IsMarker) {
        return (
            <Tooltip title={checkshortCondition(!isCanMarker, "เปิดการใช้งาน Marker", "ปิดการใช้งาน Marker")} placement="left">
                <div
                    data-testid={"btn-marker"}
                    className='btn-marker'
                    onClick={() => {
                        setisCanMarker(e => !e)
                    }}
                >
                    <LocationOnIcon style={{ display: checkshortCondition(!isCanMarker, "", "none"), color: 'red' }} />
                    <NotInterestedIcon style={{ display: checkshortCondition(isCanMarker, "", "none"), color: 'red' }} />
                </div>
            </Tooltip>
        )
    }
    return null;
}


export const PopUpInfoMapComponent = ({
    setIsOpen,
    infoWindowData,
    navigate,
    deleteMarker,
    Isdisable,
    isCanMarker
}) => {

    return (
        <InfoWindow
            position={{ lat: infoWindowData.lat, lng: infoWindowData.lng }}
            onCloseClick={() => {
                setIsOpen(false);
            }}
        >
            <div>
                <Grid container spacing={2} justifyContent={"flex-start"} alignItems={"flex-end"}>
                    <Grid item xs={12} >
                        <h3>{infoWindowData.address}</h3>
                    </Grid>
                    <Grid item xs={12} >
                        <Grid container justifyContent={"space-between"}>
                            <Grid item >
                                <div
                                    data-testid={"ViewOnGoogle"}
                                    className='underline-on-hover-text'
                                    onClick={() => { OpenNewTab(infoWindowData.url); }}
                                >
                                    ดูบน Google Maps
                                </div>
                            </Grid>
                            <Grid item >
                                <IconButton aria-label="delete" size="small" onClick={() => { deleteMarker(); }} style={{ display: checkshortCondition(!Isdisable && isCanMarker, "", "none") }}>
                                    <DeleteIcon fontSize="inherit" style={{ color: '#ff0000' }} />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </InfoWindow>
    )
}



export const checkshortCondition = (a, b, c) => {
    return CheckConditionGetValue(a, b, c);
};